module.exports = __webpack_public_path__ + "img/gpd_logo.47c8b2d8.png";